import { Component, OnInit } from '@angular/core';
import { BillersService } from 'src/app/services/billers.service'

declare var webengage
@Component({
  selector: 'app-pay-bill-home',
  templateUrl: './pay-bill-home.component.html',
  styleUrls: ['../homepage.component.scss']
})
export class PayBillHomeComponent implements OnInit {

  constructor(public billerService : BillersService) { }

  countries = []
  billers = []
  inputs = []
  billersNew = []
  categories = {}
  categoriesName = []

  ngOnInit(): void {
    this.billerService.getCountries().subscribe(res => {
      //console.log(res)
      this.countries = res['biller_countries']

    })
    // webengage.track("pay_bill_initiate", {})
  }

  onSelectCountry(country){
    this.billerService.common.showLoader()
    this.billers = []
    this.inputs = []
    this.categories = {}
    this.categoriesName = []
    if(country)
    {
      this.billerService.getBillers(country).subscribe((res)=>{
      //console.log(res['biller_catalog'])
      this.billers = res['biller_catalog']
      this.billers.forEach((biller)=>{
        if(this.categories[biller.biller_type]){
            this.categories[biller.biller_type].push(biller.biller_name)
        }
        else{
          this.categories[biller.biller_type] = new Array()
          this.categories[biller.biller_type].push(biller.biller_name)
        }
        
      })
      this.categoriesName = Object.keys(this.categories)
      this.billerService.common.stopLoader()
      },err =>{
        this.billerService.message.add({severity:'error', summary: 'Something went wrong', detail: 'Please try again later!'})
        this.billerService.common.stopLoader()
      })
    }
    else{
      this.billers = []
      this.inputs = []
      this.billerService.common.stopLoader()
    }
  }

  onSelectCategory(category){
    this.inputs = []
    this.billersNew = []
    this.billers.forEach((biller)=>{

      if(biller.biller_type == category)

        this.billersNew.push( biller )
        this.billersNew
    })
    //console.log(this.billersNew)
    
  }
}
